import useQueryState from "Components/Hooks/UseQueryState";
import AgencyFilter from "pages/Payments/AgencyFilter";
import MDAFilter from "pages/Payments/MDAFilter";
import { Card, CardBody, Row, Col, Button } from "reactstrap";
import Flatpickr from "react-flatpickr";
import RegionFilter from "pages/Payments/RegionFilter";
import OffCanvasFilter from "./OffCanvasFilter";
import { useState } from "react";

export type FilterType = {
  positionType: {
    value: string | null;
    label: string | null;
  };
  agency: {
    value: string | null;
    label: string | null;
  };
  mda: {
    value: string | null;
    label: string | null;
  };
  dateRange: {
    fromDate: Date | null;
    toDate: Date | null;
  };
  region: {
    value: string | null;
    label: string | null;
  };
  paymentCategory: {
    value: string | null;
    label: string | null;
  };
  thematicArea: {
    value: string | null;
    label: string | null;
  };
  sector: {
    value: string | null;
    label: string | null;
  };
};

export const defaultFilter: FilterType = {
  positionType: {
    value: null,
    label: null,
  },
  agency: {
    value: null,
    label: null,
  },
  mda: {
    value: null,
    label: null,
  },
  dateRange: {
    fromDate: null,
    toDate: null,
  },
  region: {
    value: null,
    label: null,
  },
  paymentCategory: {
    value: null,
    label: null,
  },
  thematicArea: {
    value: null,
    label: null,
  },
  sector: {
    value: null,
    label: null,
  },
};

const Filters = () => {
  const [filter, setFilter] = useQueryState<FilterType>(
    "filter",
    defaultFilter
  );
  const [advancedFilter, setAdvancedFilter] = useState(false);

  const clearFilters = () => {
    setFilter(defaultFilter);
  };

  return (
    <Card>
      <CardBody>
        <Row className="g-3 ">
          <Col xxl={2} lg={6}>
            {/* <h6 className="text-uppercase fs-12 mb-2">Select MDA</h6> */}
            <RegionFilter
              onChange={(value: any) => {
                setFilter({
                  ...filter,
                  region: value,
                });
              }}
              value={filter.region?.value ? filter.region : null}
            />
          </Col>
          <Col xxl={3} lg={6}>
            {/* <h6 className="text-uppercase fs-12 mb-2">Select MDA</h6> */}
            <MDAFilter
              onChange={(value: any) => {
                setFilter({
                  ...filter,
                  mda: value,
                });
              }}
              value={filter.mda?.value ? filter.mda : null}
              regionId={filter.region?.value || ""}
            />
          </Col>
          {/* <Col xxl={2} lg={6}>
            <h6 className="text-uppercase fs-12 mb-2">Select Position type</h6>
            <PositionTypeFilter
              onChange={(value: any) => {
                setFilter({
                  ...filter,
                  positionType: value,
                });
              }}
              value={filter.positionType?.value ? filter.positionType : null}
            />
          </Col> */}
          <Col xxl={3} lg={6}>
            {/* <h6 className="text-uppercase fs-12 mb-2">Select Date Range</h6> */}
            {/* @ts-ignore */}
            <Flatpickr
              className="form-control"
              placeholder="Select date range"
              options={{
                mode: "range",
                altFormat: "d M, Y",
                dateFormat: "d M, Y",
              }}
              onChange={(e) => {
                if (e[0] && e[1]) {
                  setFilter({
                    ...filter,
                    dateRange: {
                      fromDate: e[0],
                      toDate: e[1],
                    },
                  });
                }
              }}
              value={[
                filter?.dateRange?.fromDate || "",
                filter?.dateRange?.toDate || "",
              ]}
            />
          </Col>
          <Col xxl={2} lg={6}>
            {/* <h6 className="text-uppercase fs-12 mb-2">Select Agency</h6> */}
            <AgencyFilter
              onChange={(value: any) => {
                setFilter({ ...filter, agency: value });
              }}
              value={filter.agency?.value ? filter.agency : null}
            />
          </Col>
          <Col xxl={2} lg={4}>
            {/* <h6 className="text-uppercase fs-12 mb-xxl-4"> {` `}</h6> */}

            <div className="w-100 d-flex gap-2">
              <button
                className="flex-grow-1 btn btn-light"
                onClick={() => {
                  clearFilters();
                }}
              >
                <i className="ri-restart-line align-bottom me-1"></i>
                Reset{" "}
              </button>

              <Button
                color="primary"
                className="flex-grow-1"
                onClick={() => {
                  setAdvancedFilter(true);
                }}
              >
                <i className="ri-equalizer-line align-bottom me-1"></i>
                Filters
              </Button>
            </div>
          </Col>
        </Row>
      </CardBody>
      <OffCanvasFilter
        show={advancedFilter}
        onCloseClick={() => setAdvancedFilter(false)}
        clearFilters={clearFilters}
      />
    </Card>
  );
};

export default Filters;
